import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isPortalLoggedIn, fetchPendingActions } from './engagementClient';
import EngagementActionFlow from './EngagementActionFlow';

// Auto-popup that fires on portal load: queues the events the employee still has
// to act on (register / self-rate) and shows them one at a time. Dismissing one
// suppresses it for this browser session (a fresh login re-invites) — but it's
// ALSO always reachable from the leaderboard side tab, so a dismissed popup is
// never a dead end.
const DISMISS_KEY = 'ee_reg_dismissed';

function dismissed() {
  try { return new Set(JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]')); } catch (e) { return new Set(); }
}
function rememberDismiss(id) {
  const s = dismissed(); s.add(id);
  sessionStorage.setItem(DISMISS_KEY, JSON.stringify([...s]));
}

export default function EngagementRegistrationPrompt() {
  const location = useLocation(); // re-evaluate on login/logout (SPA navigations)
  const loggedIn = isPortalLoggedIn();
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    if (!loggedIn) { setQueue([]); return undefined; }
    let active = true;
    fetchPendingActions().then((events) => {
      if (active) setQueue(events.filter((e) => !dismissed().has(e.event_id)));
    });
    return () => { active = false; };
  }, [loggedIn, location.pathname]);

  const current = queue[0];
  if (!loggedIn || !current) return null;

  const advance = () => setQueue((q) => q.slice(1));
  const later = () => { rememberDismiss(current.event_id); advance(); };

  return <EngagementActionFlow event={current} onClose={later} onCompleted={advance} />;
}
